import React from 'react'

const inputType = { string: 'text', url: 'url', int: 'number', secret: 'password' }

// validateSchema returns { key: message } for required and pattern problems.
export const validateSchema = (schema, value, isNew) => {
  const out = {}
  schema.forEach(f => {
    if (f.type === 'email_list' || f.generate) return
    const v = value[f.key]
    const empty = v === undefined || v === null || v === ''
    if (f.required && empty && (isNew || !f.secret)) out[f.key] = `${f.label} is required.`
    else if (!empty && f.pattern && !new RegExp(f.pattern).test(String(v))) out[f.key] = `${f.label} does not look right.`
  })
  return out
}

// SchemaForm draws a target's config form from its action type's
// ConfigSchema (spec §12.1): a new channel type needs no admin code. Secret
// fields are write-only: once set they show "set" and can only be replaced
// (the target drawer's secret panel does that). Generated secrets (signing
// secrets) are created by the server and shown once.
export const SchemaForm = ({ schema, value, secretsSet = {}, onChange, isNew, errors = {} }) =>
  <div className="ar-form">
    {schema.filter(f => f.type !== 'email_list').map(f => {
      const id = `ar-cfg-${f.key}`
      if (f.secret && (secretsSet[f.key] || (f.generate && isNew))) {
        return <p key={f.key} className="sw-hint m-0">{f.label}: {secretsSet[f.key] ? 'set' : 'generated when you save, and shown once'}</p>
      }
      if (f.secret && !isNew) return null
      const v = value[f.key] === undefined ? (f.default === undefined ? '' : f.default) : value[f.key]
      const set = x => onChange({ ...value, [f.key]: x })
      return (
        <div className="sw-field" key={f.key}>
          {f.type === 'bool' ? (
            <div className="form-check">
              <input id={id} className="form-check-input" type="checkbox" checked={Boolean(v)} onChange={e => set(e.target.checked)} />
              <label className="form-check-label" htmlFor={id}>{f.label}</label>
            </div>
          ) : (
            <>
              <label className={`sw-label${f.required ? ' ar-required' : ''}`} htmlFor={id}>{f.label}</label>
              {f.type === 'enum' ? (
                <select id={id} className="form-select" required={Boolean(f.required)} value={v} onChange={e => set(e.target.value)}>
                  {(f.options || []).map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              ) : (
                <input id={id} className={`form-control${errors[f.key] ? ' is-invalid' : ''}`} type={inputType[f.type] || 'text'}
                  required={Boolean(f.required)} autoComplete={f.secret ? 'new-password' : 'off'} value={v}
                  onChange={e => set(f.type === 'int' ? (e.target.value === '' ? '' : Number(e.target.value)) : e.target.value)} />
              )}
            </>
          )}
          {f.help && <div className="sw-hint">{f.help}</div>}
          {errors[f.key] && <div className="invalid-feedback d-block">{errors[f.key]}</div>}
        </div>
      )
    })}
  </div>
